import { z } from "zod";

export const PlatformSchema = z.enum(["web", "ios", "android"]);
export type Platform = z.infer<typeof PlatformSchema>;

export const TestStatusSchema = z.enum(["pending", "running", "passed", "failed", "cancelled"]);
export type TestStatus = z.infer<typeof TestStatusSchema>;

export * from "./analysis";
export * from "./analysis-event";
export * from "./analysis-event-view";
export * from "./scenarios";
export * from "./onboarding";
export * from "./onboarding-step";
export * from "./suspected-cause";
export * from "./issue-report";
export * from "./evidence-tokens";
export * from "./generation";
export * from "./api-key";
export * from "./chat";
export * from "./organization";
export * from "./secrets";
export * from "./previewkit-builtins";
export * from "./previewkit-config";
export * from "./previewkit-config-rows";
export * from "./previewkit-operations";
export * from "./previewkit-resource-tiers";
export * from "./previewkit-job-spec";
export * from "./previewkit-node-build";
export * from "./previewkit-node-pm";
export * from "./previewkit-presets";
export * from "./previewkit-authorable-config";
export * from "./previewkit-runtimes";
export * from "./previewkit-redeploy-app";
export * from "./previewkit-service-suggestion";
export * from "./previewkit-env-suggestion";
export * from "./previewkit-diagnosis";
export * from "./preview-deploy-failure";
export * from "./snapshot-dependency-pin";
export * from "./snapshot-report";
export * from "./checkpoint-summary";
export * from "./pr-pipeline-status";
export * from "./step-output";
export * from "./investigation-report";
export * from "./activation-triggers";
export * from "./suite-health";
export * from "./suite-health-fix-plan";
export * from "./application-activity";
export * from "./application-memory";
